export default __webpack_public_path__ + "static/media/zener_diode.74d5eaa2.svg";